<template>

    <v-content>

        <div v-if="!moduleReport">
            <v-breadcrumbs :items="breadcrumbsItem" large></v-breadcrumbs>
            <v-row>


                <v-col cols="12"
                       sm="4"
                       md="3"
                       xl="2"
                       v-for="title in dashboardItems"
                       v-bind:key="title.link"
                       class="viewCard">
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <router-link :to="title.link">

                                <HoverCard :cardData="title"></HoverCard>

                            </router-link>
                        </template>
                    </v-tooltip>
                </v-col>
                
                <v-col v-show="usersData.departmentID == 0"
                       cols="12"
                       sm="4"
                       md="3"
                       xl="2" v-for="title in dashboardAssign"
                       v-bind:key="title.link"
                       class="viewCard">
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <router-link :to="title.link">

                                <HoverCard :cardData="title"></HoverCard>
                            </router-link>
                        </template>
                    </v-tooltip>
                </v-col>

            </v-row>
        </div>

    </v-content>




</template>

<script>
    /*import CompanyDashboardMenu from "./CompanyDashboardMenu";*/
    import axios from "axios";
    import { mapGetters } from "vuex";
    import HoverCard from '@/components/HoverCard';


    export default {
        name: "CompanySettings",
        data() {
            return {
                snackbar: {
                    formModal: false,
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    drawer: null,
                    drawerRight: null,
                    right: false,

                
                   
                },
                customerData: {
                    updateItem: {}
                },
                branchInformation: [],

            }
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            dashboardItems() {
                return [
                    {
                        name: this.$t('profile'),
                        link: "/BranchProfile",
                        icon: "mdi-earth-arrow-right"
                    },
                    {
                        name: this.$t('form_structures'),
                        link: { name: 'ReportSetting' },
                        icon: "mdi-briefcase",
                        subHeader: {}
                    },
                    {
                        name: this.$t('actual_Report'),
                        link: { name: 'ReportSettings' },
                        icon: "mdi-briefcase",
                        subHeader: {}
                    },
                    {
                        name: this.$t('approved_budget'),
                        link: { name: 'ApprovedBudget' },
                        icon: "mdi-briefcase",
                        subHeader: {}
                    },
                    {
                        name: this.$t('expenses_budget'),
                        link: { name: 'OfficeBudgetExpenses' },
                        icon: "mdi-briefcase",
                        subHeader: {}
                    },
                    {
                        name: this.$t('budget_request'),
                        link: { name: 'OfficeBudgetRequest' },
                        icon: "mdi-briefcase",
                        subHeader: {}
                    },
                    {
                        name: this.$t('budget and expenses report'),
                        link: { name: 'budgetExpensesReport' },
                        icon: "mdi-briefcase",
                        subHeader: {}
                    },
                ]
            },
            dashboardAssign() {
                return [
                    {
                        name: this.$t('assignForm'),
                        link: { name: 'departmentAssignForm' },
                        icon: "mdi-book-open",
                        subHeader: {}


                    },
                ]
            },
            breadcrumbsItem() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: true,
                        to: "/dashboard",
                        exact: true
                    },
                    
                ]
            }
        },
        methods: {
            clickEvent(route) {
                this.$router.push({name: route})
            },
            addFormModal(route) {
                this.snackbar.formModal = true
                this.dynamicComponent.current = route
            },
            dialogueClose() {
                this.customerData.updateItem = {}
                this.snackbar.formModal = false
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
            },
            openDrawer() {
                this.snackbar.drawerRight = !this.snackbar.drawerRight
            },
            async dashboardData() {
                const dashboardData = await axios.get(
                    "Branch/GetBranchInformationByBranchID"
                );
                this.branchInformation = dashboardData.data;
            },

        },
        mounted() {
            this.dashboardData()

        },

        components: {
            HoverCard
            /* 'menu-list': CompanyDashboardMenu,*/
            /*// eslint-disable-next-line vue/no-unused-components
            'CompanyForm': () => import(/!* webpackChunkName: "CompanyForm" *!/ '../company/airDestination/CompanyForm'),
            // eslint-disable-next-line vue/no-unused-components
            'SectionsForm': () => import(/!* webpackChunkName: "SectionsForm" *!/ '../company/Sections/SectionsForm'),
            // eslint-disable-next-line vue/no-unused-components
            'PeriodicBudgetForm': () => import(/!* webpackChunkName: "PeriodicBudgetForm" *!/ '../company/PeriodicBudget/PeriodicBudgetForm'),
            // eslint-disable-next-line vue/no-unused-components
            'CustomerForm': () => import(/!* webpackChunkName: "CustomerForm" *!/ '../company/customer/CustomerForm')*/
        }
    }
</script>

<style scoped lang="scss">
    .options {
        border: 2px solid white;
    }

</style>
